import { Edit, Eye, Globe, Trash2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface PublicAccessBadgeProps {
	canRead?: boolean;
	canWrite?: boolean;
	canDelete?: boolean;
	useCount?: number;
	className?: string;
}

export function PublicAccessBadge({
	canRead,
	canWrite,
	canDelete,
	useCount,
	className,
}: PublicAccessBadgeProps) {
	// Build permission string
	const permissions: string[] = [];
	if (canRead) permissions.push('Read');
	if (canWrite) permissions.push('Write');
	if (canDelete) permissions.push('Delete');

	const permText = permissions.length > 0 ? permissions.join('+') : 'Public';
	const tooltipText = `Public (${permText})${useCount ? ` - ${useCount} uses` : ''}`;

	// Choose icon based on most permissive action
	const icon = canDelete ? (
		<Trash2 className="size-3" />
	) : canWrite ? (
		<Edit className="size-3" />
	) : canRead ? (
		<Eye className="size-3" />
	) : (
		<Globe className="size-3" />
	);

	// Color based on risk level
	const variantClass = canDelete
		? 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
		: canWrite
			? 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300'
			: canRead
				? 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300'
				: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300';

	return (
		<Badge
			variant="outline"
			className={cn('inline-flex items-center gap-1 text-xs font-medium', variantClass, className)}
			title={tooltipText}
		>
			{icon}
			<span>Public</span>
		</Badge>
	);
}
